import { render, staticRenderFns } from "./PastElections.vue?vue&type=template&id=5e30a6bb&"
import script from "./PastElections.vue?vue&type=script&lang=js&"
export * from "./PastElections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports